import { render } from "./BudgetTemplateCreate.vue?vue&type=template&id=baccf64a&scoped=true"
import script from "./BudgetTemplateCreate.vue?vue&type=script&lang=js"
export * from "./BudgetTemplateCreate.vue?vue&type=script&lang=js"

import "./BudgetTemplateCreate.vue?vue&type=style&index=0&id=baccf64a&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baccf64a"]])

export default __exports__